import { Component, OnInit, Input } from '@angular/core';
import { NguCarousel } from '@ngu/carousel';

@Component({
  selector: 'app-portfolio-carousel',
  templateUrl: './portfolio-carousel.component.html',
  styleUrls: ['./portfolio-carousel.component.scss']
})
export class PortfolioCarouselComponent implements OnInit {
  @Input('backgroundGray') public backgroundGray;
  
  public carouselOptions: NguCarousel;
  public portfolios = [{
    photo: 'assets/images/zz/blog-1.jpg',
    text: `Сборка полезных видеороликов от наших партнёров`,
    title: 'YouTube-канал "КБ Кудесник"',
	url: 'https://www.youtube.com/user/kudesnickn',
  }, {
    photo: 'assets/images/zz/blog-2.jpg',
    text: `Grass. Система выдвижения Nova Pro Scala в Базис-Мебельщике 10`,
	title: 'Проектирование',
    url: 'https://www.youtube.com/watch?v=b2euotADXGY',
  }, {
    photo: 'assets/images/zz/blog-3.jpg',
    text: `Grass 02 Замена ящиков в Базис-Мебельщике 10`,
	title: 'Проектирование',
    url: 'https://www.youtube.com/watch?v=ITZUhha_kNE',
  }, {
    photo: 'assets/images/zz/blog-4.jpg',
    text: `БАЗИС 10: 11 новых инструментов для эффективного мебельного предприятия`,
	title: 'Статьи по теме',
    url: 'https://sapr.ru/article/25754',
  }]
  constructor() { }

  ngOnInit() {
    this.carouselOptions = {
      grid: { xs: 1, sm: 2, md: 3, lg: 3, all: 0 },
      slide: 2,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true
    }
  }

}
